import { HttpRequest, HttpMethod, axiosInstance } from "./http";

// Order-source / ad attribution report (Phase 1 ads spec 2026-10-13 §3.7).
// Common params: from, to (YYYY-MM-DD, +07, inclusive, ≤ 366 d), model
// (last|first), group_by, source/medium/campaign/content/lp_slug, source_channel.
// Errors: 400 invalid_range, 503 schema_missing.
const BASE = "/api/v1/bo/reports/attribution";

class AttributionReportProvider extends HttpRequest {
    // {data:{rows:[Row], totals: Row, truncated}}
    summary(params) {
        return this.request(HttpMethod.Get, `${BASE}/summary`, params);
    }

    // {data:{dates:[…], series:[{key:{source,medium}|"__other__", orders:[…], revenue_placed:[…]}]}}
    timeseries(params) {
        return this.request(HttpMethod.Get, `${BASE}/timeseries`, params);
    }

    // + page, limit ≤ 100 → {data:[order], total}
    orders(params) {
        return this.request(HttpMethod.Get, `${BASE}/orders`, params);
    }

    // CSV (UTF-8 BOM) of exactly the summary table. Binary download: axios
    // directly with responseType blob (HttpRequest.request drops a 4th arg).
    exportCsv(params) {
        return axiosInstance.get(`${BASE}/export.csv`, { params, responseType: "blob" });
    }
}

export default AttributionReportProvider;
